import styled from 'styled-components';

const colors = require('common/lib/colors/colors.less');

export const ReplySentText = styled.div`
  color: ${colors.N200};
  font-size: 12px;
  overflow: hidden;
  padding: 16px 8px;
  text-align: ${({ centered }) => (centered ? 'center' : 'left')};
  text-overflow: ellipsis;
  white-space: nowrap;
`;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-detail/ReplySentText.js